import {
  createYoutubeIframe,
  getYoutubeEmbedUrl,
  getYoutubeIframeSize,
  getYoutubeVideoType,
} from "@/utils/youtube";

export const createYoutubeContent = () => {
  const toggles = Array.from(
    document.querySelectorAll<HTMLElement>("[data-content-youtube-href]"),
  );

  for (const toggle of toggles) {
    toggle.addEventListener("click", () => {
      const href = toggle.getAttribute("data-content-youtube-href");
      const replace = getReplaceStrategy(toggle);

      if (href !== null) {
        const type = getYoutubeVideoType(href);
        const embed = getYoutubeEmbedUrl(href);
        const size = getYoutubeIframeSize(type);
        const className = toggle.classList.toString();
        const width = Number(
          toggle.getAttribute("width") ?? size.width.toString(),
        );
        const height = Number(
          toggle.getAttribute("height") ?? size.height.toString(),
        );
        const iframe = createYoutubeIframe({
          className,
          src: embed.toString(),
          width,
          height,
        });

        switch (replace) {
          case "self":
            toggle.replaceWith(iframe);
            break;
          case "content":
            toggle.parentElement?.replaceChildren(iframe);
            break;
        }
      }
    });
  }
};

const getReplaceStrategy = (toggle: HTMLElement) => {
  const replace = toggle.getAttribute("data-content-replace");

  switch (replace) {
    case "self":
      return "self";
    case "content":
      return "content";
    default:
      return "self";
  }
};
